module.exports = __webpack_public_path__ + "static/media/09_avatar_female.52bf4535.png";